import { render, staticRenderFns } from "./HeaderOnly.vue?vue&type=template&id=6bf9667a&scoped=true&"
import script from "./HeaderOnly.vue?vue&type=script&lang=js&"
export * from "./HeaderOnly.vue?vue&type=script&lang=js&"
import style0 from "./HeaderOnly.vue?vue&type=style&index=0&id=6bf9667a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf9667a",
  null
  
)

export default component.exports